// // /////////////////////////////////////////////////////////////////////////////////////
// //                              Copyright (c) 2021 - 2025
// //                                    RXO Inc.
// //                          All Rights Reserved Worldwide
// //
// // WARNING:  This program (or document) is unpublished, proprietary
// // property of RXO Inc. and is to be maintained in strict confidence.
// // Unauthorized reproduction, distribution or disclosure of this program
// // (or document), or any program (or document) derived from it is
// // prohibited by State and Federal law, and by local law outside of the U.S.
// // /////////////////////////////////////////////////////////////////////////////////////

import { cloneDeep, pick } from "lodash";

import { division as divisionType } from "./types";

export const handlePricingAnalyticsValidation = (
  filters,
  division,
  validationObj
) => {
  let validationData = cloneDeep(validationObj);
  let requiredFields = [
    "ranks",
    "origin",
    "originRadius",
    "destination",
    "destinationRadius"
  ];

  requiredFields.forEach(
    field => filters[field] || setValidationDataObj(field, true, validationData)
  );

  ["originRadius", "destinationRadius"].forEach(
    field =>
      filters[field] &&
      radiusValidation(field, filters[field], division, validationData)
  );

  requiredFields.push("equipments");
  if (
    division === divisionType.coy &&
    filters.equipments === null
  ) {
    setValidationDataObj("equipments", true, validationData);
  } else {
    setValidationDataObj("equipments", false, validationData);
  }

  const allValid = Object.values(pick(validationData, ...requiredFields)).every(
    prop => prop.isError !== true
  );

  return { allValid, validationData };
};

const radiusValidation = (field, radius, division, validationData) => {
  let error = false;
  if (radius === null) {
    error = true;
  } else if (division === divisionType.eu && radius > 150) {
    error = true;
  } else if (division === divisionType.coy && radius > 125) {
    error = true;
  }
  setValidationDataObj(field, error, validationData);
};

export const removePricingAnalyticsValidation = (validationObj, field) => {
  let validationData = cloneDeep(validationObj);

  setValidationDataObj(field, false, validationData);

  return { validationData };
};

const setValidationDataObj = (field, isError, validationData) => {
  validationData[field] = {
    isError: isError
  };
};
